import React from 'react';
import { Box, Typography, Paper, Link } from '@mui/material';

export default function Kontakt() {
  return (
    <Box sx={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      p: 3 
    }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom color="primary">
          Ihre Kontaktaufnahme
        </Typography>
        
        <Typography paragraph>
          Geehrter Besucher,
        </Typography>

        <Typography paragraph>
          sehr gerne nehmen wir Ihre Kritik, Anregungen und Anmerkungen für die Webseite sozialgerichtsbarkeit.de entgegen.
        </Typography>

        <Typography paragraph>
          Bitte haben Sie jedoch Verständnis dafür, dass wir auf diesem Wege keine Rechtsberatung anbieten oder 
          Auskunft zu Urteilen oder laufenden Verfahren geben können. <Typography component="span" sx={{ fontWeight: 'bold', textDecoration: 'underline' }}>
          Weiter ist es nicht möglich Klage, Berufung, Revision oder sonstige Rechtsmittel einzulegen.</Typography>
        </Typography>

        <Typography paragraph>
          Wenden Sie sich hierfür bitte an die entsprechende Stelle.
        </Typography>

        <Typography paragraph>
          Ihre Nachrichten senden Sie bitte per E-Mail an{' '}
          <Link href="mailto:webmaster-sgb@lsg.bayern.de">
            webmaster-sgb@lsg.bayern.de
          </Link>
        </Typography>

        <Typography paragraph>
          mit freundlichen Grüßen<br />
          Das Team von sozialgerichtsbarkeit.de
        </Typography>
      </Paper>
    </Box>
  );
} 